export default __webpack_public_path__ + "static/abiolaSCA-372e0d2fc2bb3d44b2443aad11b8bcbb.webp";